import { useSocialHubCompleteNewsVisualizationMutationMutation } from './graphql/social-hub-complete-news-visualization-mutation.v5.generated';
import { useGetSocialHubNews } from './use-get-socia-hub-news';

export const useCompleteNewsVisualization = (
  centralizedOrganizationId: number,
) => {
  const { refetch } = useGetSocialHubNews(centralizedOrganizationId);
  const [mutation, { loading, error }] =
    useSocialHubCompleteNewsVisualizationMutationMutation({
      notifyOnNetworkStatusChange: true,
      context: { clientName: 'v5' },
    });

  const completeNewsVisualization = (currentNewsId: number) =>
    mutation({
      variables: {
        input: {
          centralized_organization_id: centralizedOrganizationId,
          user_news_id: currentNewsId,
        },
      },
    })
      .then(async res => {
        if (
          res.data?.social_hub.complete_user_news.__typename ===
          'HRISDefaultResponse'
        ) {
          await refetch();
          return { success: res.data.social_hub.complete_user_news.success };
        }

        return { success: false };
      })
      .catch(err => {
        if (process.env.NODE_ENV !== 'production') {
          console.error(err);
        }

        return { success: false };
      });

  return {
    completeNewsVisualization,
    loading,
    error,
  };
};
